<template>
  <q-page class="flex-center">
    <div class="q-pa-md ">
      <h2>Nova campanha</h2>
      <q-input label="Nome da campanha *"  v-model="form.name"/>
      <br>
      <q-input label="Cor de fundo " v-model="form.background_color"/>
      <br>
      <q-input label="Código de analitycs " v-model="form.analitycs"/>
      <br>
      <q-input outlined mask="##/##/####"
               v-model="form.started_at" label="Data de início">

        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy ref="qDateProxy">
              <q-date v-model="form.started_at" mask="DD/MM/YYYY" @input="() => $refs.qDateProxy.hide()"/>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
      <br>
      <q-select
        label="Email de registro na campanha"
        :options="emailTemplateAll"
        map-options
        emit-value
        v-model="form.email_init_id"
        option-value="id"
        option-label="name"
      />
      <br> <q-select
        label="Email de pagamento na campanha"
        :options="emailTemplateAll"
        map-options
        emit-value
        v-model="form.email_finit_id"
        option-value="id"
        option-label="name"
      />
      <br>
      <q-uploader
        :url="url"
        label="Imagem de fundo"
        :factory="uploadFactory"
        color="purple-10"
        send-raw
        with-credentials
        :max-file-size="maxSize"
        :auto-upload="true"
        @uploaded="finished"
        @finish="finished"
        @removed="form.file = ''"
      >
      </q-uploader><br>
      <q-uploader
        :url="url"
        label="Imagem de agradecimento"
        :factory="uploadFactoryAcknowledgment"
        color="purple-10"
        send-raw
        with-credentials
        :max-file-size="maxSize"
        :auto-upload="true"
        @uploaded="finished"
        @finish="finished"
        @removed="form.file = ''"
      >
      </q-uploader>
      <br>

      <q-btn label="Salvar"  @click="salvar" color="primary"/>
    </div>
    <q-inner-loading :showing="loading">
      <q-spinner-dots size="50px" color="primary"/>
    </q-inner-loading>
  </q-page>
</template>

<script>
import { EMAIL_TEMPLATE_ALL, NEW_BACKGROUND_CAMPANGN, NEW_CAMPANGN } from '@/graphql/graphql'

export default {
  name: 'NewCampangn',
  data () {
    return {

      maxSize: 10 * 1024 * 1024 * 1024,
      url: '',
      loading: false,
      emailTemplateAll: [],
      form: {
        name: '',
        email_init_id: '',
        email_finit_id: '',
        started_at: '',
        acknowledgment: '',
        background: '',
        background_color: '',
        analitycs: ''
      }
    }
  },
  methods: {
    salvar () {
      this.loading = true
      this.$apollo.mutate({
        mutation: NEW_CAMPANGN,
        variables: {
          ...this.form
        },
        update: (store, data) => {
          if (data.data.newCampangn.id) {
            this.loading = false
            alert('Campanha cadastrada com sucesso!')
            this.$router.push({ name: 'campanhas' })
          }
        }
      })
    },
    finished () {
      this.$store.dispatch('setLoading')
      this.openDialog = false
    },
    uploadFactory (file) {
      this.$store.dispatch('setLoading')
      return (

        this.$apollo.mutate({
          mutation: NEW_BACKGROUND_CAMPANGN,
          variables: { file: file[0] },
          context: {
            hasUpload: true
          },
          update: (store, data) => {
            console.log(data.data.newBackgroundCampangn.url)
            this.form.background = data.data.newBackgroundCampangn.url
          }
        })
          .catch(error => {
            console.error(error)
            const errors = { error }
            this.alertError = true
            this.titleError = errors.error.graphQLErrors[0].message
            this.messageError = errors.error.graphQLErrors[0].debugMessage
            console.error(errors.error.graphQLErrors[0].trace[0])
          })

      )
      // return new Promise(resolve, reject);
    },
    uploadFactoryAcknowledgment (file) {
      this.$store.dispatch('setLoading')
      return (

        this.$apollo.mutate({
          mutation: NEW_BACKGROUND_CAMPANGN,
          variables: { file: file[0] },
          context: {
            hasUpload: true
          },
          update: (store, data) => {
            console.log(data.data.newBackgroundCampangn.url)
            this.form.acknowledgment = data.data.newBackgroundCampangn.url
          }
        })
          .catch(error => {
            console.error(error)
            const errors = { error }
            this.alertError = true
            this.titleError = errors.error.graphQLErrors[0].message
            this.messageError = errors.error.graphQLErrors[0].debugMessage
            console.error(errors.error.graphQLErrors[0].trace[0])
          })

      )
      // return new Promise(resolve, reject);
    }
  },
  apollo: {
    emailTemplateAll: {
      query: EMAIL_TEMPLATE_ALL
    }
  }
}
</script>
